import { createContext } from 'react'

// Usage of AnnotationSortOrder will not break the build
// eslint-disable-next-line no-restricted-imports
import { AnnotationSortOrder } from '@sketch/gql-types/expansive'

import {
  AnnotationStatusFilterWithoutUnread,
  AnnotationSubject,
} from '../../types'

export interface AnnotationQueryVariablesContextValue {
  shareIdentifier?: string
  versionIdentifier?: string
  subjects: AnnotationSubject[]
  annotationStatus: AnnotationStatusFilterWithoutUnread
  annotationSort: AnnotationSortOrder
}

export interface AnnotationQueryVariablesContextValueWithPreview
  extends AnnotationQueryVariablesContextValue {
  /**
   * Mirrors the value from `shares/views/PreviewView/PreviewContext` so
   * annotations components can read it without importing the shares module
   * directly. The provider populates it; consumers default to `false` when no
   * provider is mounted.
   */
  isPreview: boolean
}

export const AnnotationQueryVariablesContext =
  createContext<AnnotationQueryVariablesContextValueWithPreview | null>(null)
